import { render, staticRenderFns } from "./transform.vue?vue&type=template&id=28f6e1fb&scoped=true&"
import script from "./transform.vue?vue&type=script&lang=js&"
export * from "./transform.vue?vue&type=script&lang=js&"
import style0 from "./transform.vue?vue&type=style&index=0&id=28f6e1fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f6e1fb",
  null
  
)

export default component.exports